import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Center,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../../../../../../../common/src/components/LoadingSpinner';
import { TreeItem } from '../../../../../../../design-system/src/content/components/TreeList';
import AskLaterQuestionsModalBody from './AskLaterQuestionsModalBody';
import { AskLaterQuestion } from './types';

interface Props {
  questionList?: AskLaterQuestion[];
  data: TreeItem[];
  isOpen: boolean;
  onClose: () => void;
  isRemoveEnabled?: boolean;
  isLoading?: boolean;
}

const AskLaterQuestionsModal: React.FC<Props> = ({
  questionList,
  data,
  isOpen,
  onClose,
  isRemoveEnabled = false,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="3xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {t('COMPANY-SCAN_QUESTION-FLOW_ASKED-LATER-QUESTIONS_MODAL_TITLE')}{' '}
          {questionList && `(${questionList.length})`}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {questionList && !isLoading ? (
            <AskLaterQuestionsModalBody
              data={data}
              askLaterQuestions={questionList}
              onClose={onClose}
              isRemoveEnabled={isRemoveEnabled}
            />
          ) : (
            <Center>
              <LoadingSpinner />
            </Center>
          )}
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            {t('CLOSE')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AskLaterQuestionsModal;
